import { atom } from "jotai";

export type MapBounds = [[number, number], [number, number]];

export type StatefulFilters = {
  filteredContextId?: string;
  operations?: string[];
  years?: number[];
  crops?: string[];
  additionalFilters?: Record<string, unknown>;
  mapBounds?: MapBounds;
};
export const emptyStatefulFilters: StatefulFilters = {
  filteredContextId: undefined,
  operations: undefined,
  years: undefined,
  crops: undefined,
  mapBounds: undefined,
};
/**
 * Atom to track stateful filters across the application. This value gets hydrated
 * in the useFilterState hook from the indexedDB persisted data. As the data here
 * gets updated, we keep indexedDB in sync with the latest state.
 *
 * We clear this value when the operating context changes; that reset is owned by
 * the mode/context-change effect in `useFilterState.ts`.
 */
export const statefulFiltersAtom = atom<StatefulFilters>(emptyStatefulFilters);
